import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const fetchAgentRate = createAsyncThunk(
  "AgentRate/fetchAgentRate",
  async (agent_id, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/order/agentrate`,
        { agent_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.rates;
    } catch (error) {
      console.error("Error fetching perviews", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

const initialState = {
  AgentRate: [],
  status: "idle",
  error: null,
};

const getAgentRateIdSlice = createSlice({
  name: "AgentRate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgentRate.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAgentRate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.AgentRate = action.payload;
      })
      .addCase(fetchAgentRate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default getAgentRateIdSlice.reducer;